import EmailErrorControl from '@/core/components/UserControl/controls/EmailErrorControl/EmailErrorControl';

export default EmailErrorControl;
